import React, {Component} from 'react';

class AccessDenied extends Component {
  render() {
    return (
      <div style={{ marginTop: '10%' }}>
        <div style={{ textAlign: 'center', color: 'white' }}>
          <h1>Access Denied.</h1>
          <h3>You don't have access to this Page</h3>
        </div>
      </div>
    );
  }
}

export default AccessDenied;



// WEBPACK FOOTER //
// ./components/AccessDenied.js